/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Browser_Chat_EmptyInputs */



/**
* | output |
* | --- |
* | "Documents, presentations and canvases from this chat appear here." |
*
* @param {Artifact_Browser_Chat_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_browser_chat_empty = /** @type {((inputs?: Artifact_Browser_Chat_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Browser_Chat_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokumente, Präsentationen und Canvases aus diesem Chat erscheinen hier.")
	return /** @type {LocalizedString} */ ("Documents, presentations and canvases from this chat appear here.")
});